export default __webpack_public_path__ + "static/media/gallery_03.548f296a.jpg";